import { render, staticRenderFns } from "./TableConcubine.vue?vue&type=template&id=b86f307a"
import script from "./TableConcubine.vue?vue&type=script&lang=ts"
export * from "./TableConcubine.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports